import { defineComponent, reactive } from "vue";
import { Log } from "~/extensions/utils";
import { store } from "../../store/TaikyoStore";
import { KaiyakuEntryHasonPageValidator } from "../Models/KaiyakuEntryPageValidator";
const log = Log.create("Kaiyaku.Entry.Hason");
// エラーメッセージ定数
const ERROR_MESSAGES = {
    REQUIRED_CHECKBOX: "修繕項目を選択してください。"
};
export default defineComponent({
    name: "KaiyakuEntryHasonTable",
    props: {
        readonly: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        // ストアデータ
        const hasonInfo = reactive(store.hasonInfo);
        // バリデータを初期化
        const valid = reactive(new KaiyakuEntryHasonPageValidator(hasonInfo));
        /**
         * 対象箇所チェック時のイベント
         * チェックが外された場合、配下の箇所チェックもクリア
         */
        const changeSelected = (hason) => {
            if (!hason.isSelected) {
                hason.checkedArray.forEach(check => {
                    check.isChecked = false;
                });
            }
        };
        /**
         * 「破損なし」選択時のイベント
         * 破損なしが選択された場合、全ての選択情報と記入スペースをクリア
         */
        const changeNothing = (hasonData) => {
            if (hasonData.isNothing) {
                hasonData.remarks = "";
                hasonData.hasonList.forEach(card => {
                    card.isSelected = false;
                    card.checkedArray.forEach(check => {
                        check.isChecked = false;
                    });
                });
            }
        };
        return {
            // ストアデータ
            hasonInfo,
            // バリデーション
            valid,
            // エラーメッセージ
            requiredCheckBoxErrorMessage: ERROR_MESSAGES.REQUIRED_CHECKBOX,
            // ハンドラー
            changeSelected,
            changeNothing,
            // ユーティリティ
            log
        };
    }
});
